<picture class="py-10 px-0 max-lg:border-l lg:border-t border-solid border-[#494e6e] w-full flex justify-center items-center max-lg:py-0 max-lg:px-7 max-sm:py-0 max-sm:px-5">
    <div class="block overflow-hidden relative m-0 box-border z-[1] w-11 h-11 rounded-full max-lg:w-9 max-lg:h-9">
        <img
            src="https://api.dicebear.com/7.x/bottts/svg?seed={Math.random() * 21839}"
            alt="avatar"
            width="100%"
            height="auto"
            layout="responsive"
        />
    </div>
</picture>
